import {AiEngineTypeId, AIGamesRecommendations} from "../ai-recommendations-reader.service.interface";
import {GamesRecommendationsBaseModel} from "./games-recommendations-base.model";
import {LocalStorageKeys} from "../../storage/local-storage-keys";
import {NullableString} from "../../../../common/types/nullable-types";
import {FEATURE_GAME_RECOMMENDATIONS} from "../../../../common/const/ab-testing-names";


export class RegularGamesRecommendationsModel extends GamesRecommendationsBaseModel {
    protected get localStorageKey(): string {
        return LocalStorageKeys.aiRegularGamesRecommendations;
    }

    protected async _readGamesRecommendationsFromServer(): Promise<AIGamesRecommendations> {
        if(!this._playerHasRecommendations()) {
            return {
                engine: null,
                gameTypes: []
            }
        }

        const response = await this.services.api.insightController.getGameRecommendationsForPlayer({
            engineType: this._getEngineID()
        });

        return {
            engine: response.Engine,
            gameTypes: response.GameTypes ?? []
        }

    }

    private _playerHasRecommendations(): boolean {
        const engine = this._getGameRecommendationsEngine();
        if (engine) {
            const noRecommendationMatches = engine.match(/no\s*recommendation/gi) || [];
            return noRecommendationMatches.length === 0;
        }
        return true;
    }

    private _getGameRecommendationsEngine(): NullableString {
        const abFeature = this.services.abTestingFeatureDataProvider.getFeature(FEATURE_GAME_RECOMMENDATIONS);

        if (abFeature?.Properties) {
            return abFeature?.Properties['Engine'] ?? null;
        }
        return null;
    }

    private _getEngineID(): number {
        const engine = this._getGameRecommendationsEngine();
        return AiEngineTypeId[engine?.toUpperCase()] ?? 0;

    }
}